<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-file-document-alert</v-icon>
            Tocas sin Resumen IA
            <v-spacer></v-spacer>
            <v-chip color="orange" dark class="mr-3">
              {{ totalSinResumen }} pendientes
            </v-chip>
            <v-btn color="primary" small @click="fetchTocas" :loading="loading">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row dense align="center">
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model="filters.search"
                  label="Buscar por ID o número"
                  dense
                  outlined
                  clearable
                  hide-details
                  @keyup.enter="fetchTocas"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model="filters.fecha_ini"
                  label="Fecha pub. inicio"
                  type="date"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model="filters.fecha_fin"
                  label="Fecha pub. fin"
                  type="date"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn color="primary" block height="40" @click="fetchTocas" :loading="loading">
                  Filtrar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" class="text-right">
                <v-btn
                  color="success"
                  height="40"
                  :disabled="selected.length === 0"
                  :loading="enviando"
                  @click="enviarSeleccionadas"
                >
                  <v-icon left>mdi-send</v-icon>
                  Enviar {{ selected.length }} a generar resumen
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <span class="text-caption grey--text">
                  Selecciona las tocas que deseas enviar a generar resumen con IA. Máximo 100 por envío.
                </span>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Tabla con checkboxes -->
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="tocas"
            :loading="loading"
            :items-per-page="50"
            show-select
            item-key="id"
            class="elevation-0"
            dense
            :server-items-length="totalSinResumen"
            :options.sync="options"
            @update:options="onOptionsChange"
            :footer-props="{ 'items-per-page-options': [20, 50, 100] }"
          >
            <!-- Toca (numero/periodo) -->
            <template v-slot:item.toca_numero="{ item }">
              <span>{{ item.numero }}/{{ item.periodo }}</span>
            </template>

            <!-- Sala -->
            <template v-slot:item.salas="{ item }">
              <span v-if="item.salas">{{ item.salas.nombre }}</span>
              <span v-else class="grey--text">—</span>
            </template>

            <!-- Fecha emisión -->
            <template v-slot:item.fecha_emision="{ item }">
              <span class="text-caption">{{ formatDate(item.fecha_emision) }}</span>
            </template>

            <!-- Fecha publicación -->
            <template v-slot:item.fecha_publicacion="{ item }">
              <span class="text-caption">{{ formatDate(item.fecha_publicacion) }}</span>
            </template>

            <!-- Fecha creación -->
            <template v-slot:item.created_at="{ item }">
              <span class="text-caption">{{ formatDate(item.created_at) }}</span>
            </template>

            <!-- Archivo -->
            <template v-slot:item.file="{ item }">
              <v-icon v-if="item.file" small color="green">mdi-check-circle</v-icon>
              <v-icon v-else small color="red">mdi-close-circle</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="5000">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import ApiService from "@/services/ApiService";

export default {
  name: "TocasSinResumen",
  data() {
    return {
      tocas: [],
      selected: [],
      totalSinResumen: 0,
      loading: false,
      enviando: false,
      options: {},
      filters: {
        search: null,
        fecha_ini: null,
        fecha_fin: null,
      },
      headers: [
        { text: "ID", value: "id", width: "80px" },
        { text: "Toca", value: "toca_numero", width: "120px" },
        { text: "Sala", value: "salas", width: "200px" },
        { text: "PDF", value: "file", width: "60px", align: "center" },
        { text: "F. Emisión", value: "fecha_emision", width: "120px" },
        { text: "F. Publicación", value: "fecha_publicacion", width: "120px" },
        { text: "F. Creación", value: "created_at", width: "120px" },
      ],
      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
    };
  },
  mounted() {
    this.fetchTocas();
  },
  methods: {
    onOptionsChange() {
      this.fetchTocas();
    },
    async fetchTocas() {
      this.loading = true;
      try {
        var page = this.options.page || 1;
        var perPage = this.options.itemsPerPage || 50;

        var params = { page: page, per_page: perPage };
        if (this.filters.search) params.search = this.filters.search;
        if (this.filters.fecha_ini) params.fecha_ini = this.filters.fecha_ini;
        if (this.filters.fecha_fin) params.fecha_fin = this.filters.fecha_fin;

        var response = await ApiService.get({
          url: "/tocas-sin-resumen",
          data: params
        });

        this.tocas = response.data.data.tocas.data || [];
        this.totalSinResumen = response.data.data.total_sin_resumen || 0;
      } catch (error) {
        console.error("Error cargando tocas sin resumen:", error);
        this.showSnackbar("Error al cargar las tocas", "error");
      } finally {
        this.loading = false;
      }
    },
    async enviarSeleccionadas() {
      if (this.selected.length === 0) return;
      if (this.selected.length > 100) {
        this.showSnackbar("Máximo 100 tocas por envío", "warning");
        return;
      }

      this.enviando = true;
      try {
        var ids = this.selected.map(function(t) { return t.id; });

        var response = await ApiService.postJSON({
          url: "/tocas-enviar-resumen",
          data: { toca_ids: ids },
        });

        var data = response.data.data;
        this.showSnackbar(data.message, "success");

        if (data.errores && data.errores.length > 0) {
          console.warn("Errores al enviar:", data.errores);
        }

        // Limpiar selección y refrescar
        this.selected = [];
        this.fetchTocas();
      } catch (error) {
        var msg = (error.response && error.response.data && error.response.data.message) || "Error al enviar";
        this.showSnackbar(msg, "error");
      } finally {
        this.enviando = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "—";
      // Quitar la parte de hora si viene en formato ISO (T...) o con espacio
      var clean = dateStr.split("T")[0].split(" ")[0];
      var pieces = clean.split("-");
      if (pieces.length === 3) {
        return pieces[2] + "/" + pieces[1] + "/" + pieces[0];
      }
      return clean;
    },
    showSnackbar(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
  },
};
</script>
